import { Stack } from "basis";
import { AccountWithPersonalDetails } from "../types";
import { AccountSection } from "./AccountSection";

type Props = {
  accountsWithPersonalDetails: AccountWithPersonalDetails[];
};

export const AccountsList = ({ accountsWithPersonalDetails }: Props) => (
  <Stack gap="10">
    {accountsWithPersonalDetails.map((accountWithPersonalDetails) => (
      <AccountSection
        accountWithPersonalDetails={accountWithPersonalDetails}
        key={accountWithPersonalDetails.account.account_id}
      />
    ))}
  </Stack>
);
